// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/broadcast-messages/app/css/app.css
// module id = 798
// module chunks = 0